import $ from "jquery";
import { io } from "socket.io-client";
import { getOfflineInterceptor } from "./libs/offline/interceptor";
import { getNetworkService } from "./libs/offline/network";
import { getSyncService } from "./libs/offline/sync";
import { getPrefetchService } from "./libs/offline/prefetch";
import { getOfflineStorage } from "./libs/offline/storage";

const CAPACITOR_SERVER_ORIGIN = 'https://safety.inspectpro.seasonai.net';

function isNativePlatform(): boolean {
    const capacitor = (window as any).Capacitor;
    return !!capacitor && !!capacitor.isNativePlatform && capacitor.isNativePlatform();
}

function resolveBaseUri(baseuri: any): string {
    const normalized = String(baseuri || '').trim();
    if (!normalized) return normalized;
    if (/^https?:\/\//.test(normalized)) return normalized;
    if (!isNativePlatform()) return normalized;

    return normalized.startsWith('/')
        ? `${CAPACITOR_SERVER_ORIGIN}${normalized}`
        : `${CAPACITOR_SERVER_ORIGIN}/${normalized}`;
}

export default class Wiz {
    public namespace: any;
    public baseuri: any;
    private _interceptor: any;
    private _network: any;
    private _sync: any;
    private _prefetch: any;
    private _storage: any;

    constructor(baseuri: any) {
        this.baseuri = resolveBaseUri(baseuri);
        this._interceptor = getOfflineInterceptor();
        this._network = getNetworkService();
        this._sync = getSyncService();
        this._prefetch = getPrefetchService();
        this._storage = getOfflineStorage();
        this._network.setServerUrl(this.baseuri);
        this._prefetch.setBaseUri(this.baseuri);
    }

    public app(namespace: any) {
        let instance = new Wiz(this.baseuri);
        instance.namespace = namespace;
        return instance;
    }

    public dev() {
        let findcookie = (name: string) => {
            let ca: Array<string> = document.cookie.split(';');
            let caLen: number = ca.length;
            let cookieName = `${name}=`;
            let c: string;

            for (let i: number = 0; i < caLen; i += 1) {
                c = ca[i].replace(/^\s+/g, '');
                if (c.indexOf(cookieName) == 0) {
                    return c.substring(cookieName.length, c.length);
                }
            }
            return '';
        }

        let isdev = findcookie("season-wiz-devmode");
        if (isdev == 'true') return true;
        return false;
    }

    public project() {
        let findcookie = (name: string) => {
            let ca: Array<string> = document.cookie.split(';');
            let caLen: number = ca.length;
            let cookieName = `${name}=`;
            let c: string;

            for (let i: number = 0; i < caLen; i += 1) {
                c = ca[i].replace(/^\s+/g, '');
                if (c.indexOf(cookieName) == 0) {
                    return c.substring(cookieName.length, c.length);
                }
            }
            return '';
        }

        let project = findcookie("season-wiz-project");
        if (project) return project;
        return "main";
    }

    public socket() {
        let socketns = this.baseuri + "/app/" + this.project();
        if (this.namespace)
            socketns = socketns + "/" + this.namespace;
        return io(socketns);
    };

    public url(function_name: string) {
        if (function_name[0] == "/") function_name = function_name.substring(1);
        return this.baseuri + "/api/" + this.namespace + "/" + function_name;
    }

    public async call(function_name: string, data: any = {}, options: any = {}) {
        if (function_name[0] == "/") function_name = function_name.substring(1);

        try {
            return await this._interceptor.call(
                this.baseuri, this.namespace, function_name, data, options
            );
        } catch (err) {
            // Fallback to direct ajax (legacy behavior)
            return new Promise((resolve) => {
                $.ajax({
                    url: this.url(function_name),
                    type: "POST",
                    data: data,
                    crossDomain: /^https?:\/\//.test(this.url(function_name)),
                    xhrFields: {
                        withCredentials: true,
                        ...(options && options.xhrFields ? options.xhrFields : {})
                    },
                    ...options
                }).always(function (res: any) {
                    resolve(res);
                });
            });
        }
    }

    // === Offline utilities ===
    public get offline() {
        return {
            network: this._network,
            sync: this._sync,
            prefetch: this._prefetch,
            storage: this._storage,
            isOnline: () => this._network.isOnline,
            isOffline: () => !this._network.isOnline,
            pendingSync: () => this._sync.getPendingCount(),
            forcSync: () => this._sync.syncAll()
        };
    }
}
